import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/ics-logo-amphenol-tag.png")